// extracted by extract-css-chunks-webpack-plugin
module.exports = {"backButton":"_3ud0mJ","button":"UYe3g0","closeButton":"_16ibhU","content":"_1uiJqZ","navContainer":"_1N5j5q"};